<template>
	<section class="auth-view screen">
		<div class="auth-header">
			<white-nav-bar route-name="login" back-or-close="close"
				>Authenticating user...</white-nav-bar
			>
		</div>
	</section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import WhiteNavBar from '../../ui/WhiteNavBar'
import { getUrlParams } from '../../utilities'

export default {
	name: 'token-auth',
	components: { WhiteNavBar },
	props: ['uuid', 'path'],
	computed: {
		...mapState({
			me: ({ me }) => me.current
		})
	},
	data() {
		return {
			isLoading: false,
			password: '',
			showLogin: false
		}
	},
	methods: {
		...mapActions(['loginWithToken'])
	},
	mounted() {
		const path = this.path.toLowerCase()
		this.isLoading = true
		window.analytics.track('login_with_token', { path: path })
		const params = getUrlParams(window.location.href)
		if (params.handoff === 'true') {
			localStorage.setItem('token', this.uuid)
			this.isLoading = false
			delete params['handoff']
			delete params.handoff
			if (this.path) {
				this.$router.push({ name: path, query: params })
			}
		} else if (localStorage.getItem('token')) {
			delete params['handoff']
			delete params.handoff
			this.isLoading = false
			this.$router.push({ name: path, query: params })
		} else {
			delete params['handoff']
			delete params.handoff
			this.loginWithToken(this.uuid)
				.then(() => {
					this.isLoading = false
					this.$router.push({ name: path, query: params })
				})
				.catch(() => {
					this.isLoading = false
					this.showLogin = true
					this.$router.push({
						name: 'login',
						params: { redirect: path },
						query: params
					})
				})
		}
	}
}
</script>

<style lang="scss">
@import '../../styles/elements';
</style>
